import {
  Activity,
  Bell,
  Folder,
  Users2,
  BellDot,
  LucideIcon,
  Split,
  Heart,
  Smile,
  MessagesSquareIcon,
  TriangleAlert,
} from 'lucide-react';
import { CircleBackslashIcon, SymbolIcon } from '@radix-ui/react-icons';
import { IconProps } from '@radix-ui/react-icons/dist/types';

export const InteractionsIconZ: IconType = Activity;
export const ConversationsIconZ: IconType = MessagesSquareIcon;
export const UsersIconZ: IconType = Users2;
export const TopicsIconZ: IconType = Folder;
export const RetentionIconZ: IconType = SymbolIcon;
export const ErrorRateIconZ: IconType = CircleBackslashIcon;
export const BehaviourIconZ: IconType = TriangleAlert;
export const NotificationIconZ: IconType = Bell;
export const ReadNotificationIconZ: IconType = BellDot;
export const UserFeedbackIconZ: IconType = CircleBackslashIcon;
export const ABTestIconZ: IconType = Split;
export const SentimentIconZ: IconType = Heart;
export const EmotionsIconZ: IconType = Smile;

export type IconType = LucideIcon | React.ForwardRefExoticComponent<IconProps & React.RefAttributes<SVGSVGElement>>;
